import {
  Alert,
  Box,
  Button,
  Card,
  Chip,
  IconButton,
  Link,
  ListItemButton,
  MenuItem,
  Select,
  Stack,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useHistory } from "react-router-dom";
import { getActiveOrganisation, useIdentity } from "contexts/identity-context";
import { resolveIdentityId } from "utils/identity";
import { useQuery } from "react-query";
import * as QueryKeys from "data";
import { fetchBatches } from "data/queries";
import CustomTable from "components/shared/table";
import { useState } from "react";
import * as Routes from "routes";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MapIcon from "@mui/icons-material/Map";
import _ from "lodash";
import {
  BatchConfigProps,
  StepperControlProps,
} from "pages/geoscape-batch/types";
interface ViewSampleBatchJobProps {}

export const ViewSampleBatchJob = (
  props: ViewSampleBatchJobProps & BatchConfigProps & StepperControlProps
) => {
  return (
    <Card
      sx={{
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "32px",
      }}
    >
      <Box>
        <Typography variant="h5">Preview</Typography>
        <Typography variant="subtitle1" sx={{ color: "grey" }}>
          View a sample of your batch job.
        </Typography>
      </Box>
      Coming soon!
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        <Button
          onClick={() => props.setActiveStep(Math.max(props.activeStep - 1, 0))}
        >
          Back
        </Button>
        <Button
          onClick={() => {
            props.setActiveStep(Math.min(props.activeStep + 1, props.maxSteps));
            props.saveBatchConfig();
          }}
          variant="contained"
        >
          Continue
        </Button>
      </Box>
    </Card>
  );
};
